import React, {useCallback} from 'react'
import { useEffect, useState } from 'react'
import { formatTimestamp } from '../../utils/string.utils'
import {getUserRequests, getAttachment, updateReaded} from '../../api/request'
import LoadPanel from 'devextreme-react/load-panel'
import notify from 'devextreme/ui/notify'
import './letters.scss'
import { useAuth } from '../../contexts/auth'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faComments} from "@fortawesome/free-solid-svg-icons";
import {Button} from "devextreme-react/button"
import { useReqPopup } from '../../contexts/req-popup'
import { Buffer } from 'buffer';
import DataGrid, {
    Column,
    Selection,
    MasterDetail,
    Paging,
    SearchPanel,
    Toolbar,
    Pager
} from "devextreme-react/data-grid";
import {Item} from "devextreme-react/toolbar";
const Letters = () => {

    const [requests, setUserRequests] = useState()
    const [loading, setLoading] = useState(false)
    const [loadingAttach, setLoadingAttach] = useState(false)
    const { lettersCount, setLettersCount, dogovors } = useAuth()
    const { openReqPopup, sendMessage } = useReqPopup()

    const getmessage = useCallback(async() => {
        setLoading(true)
        //получаем пользовательские сообщения
        const res_requests = await getUserRequests()
        if (res_requests.isOk) {
            setUserRequests(res_requests.data)
        } else {
            console.log(res_requests.message)
            notify(res_requests.message, 'error', 5000)
        }
        setLoading(false)
    },[])

    useEffect(() => {
        (async function () {
            await getmessage()
        })()
    }, [getmessage])

    useEffect(() => {
        (async function () {
            if (sendMessage){
                await getmessage()
                //setSendMessage(false)
            }
        })()
    }, [sendMessage, getmessage])

    // в 2025 году ставим новый логотип для Рязани
    const [numLogo, setNumLogo] = useState('')
    useEffect(() => {
        let date = new Date()
        let oldLogo = date.getFullYear() < 2025
        let t = (process.env.REACT_APP_NAME_ENV === 'renergy' && oldLogo) ? '2': ''
        setNumLogo(t)
    }, [])

    const saveAttachment = async (e) => {
        const idAttach = e.target.id

        setLoadingAttach(true)

        const res = await getAttachment(idAttach)
        if (res.isOk) {
            const data = res.data.attachment?.data
            if (!data){
                setLoadingAttach(false)
                notify('Файл не найден','error',5000)
                return
            }
            const filename  = res.data.name

            let fileDownload = require('js-file-download')
            fileDownload(Buffer.from(data), filename)

        } else notify(res.message,'error',5000)

        setLoadingAttach(false)

    }

    const onRowClick = async (e) => {
        if (e.rowType !== 'data') return
        let key = e.component.getKeyByRowIndex(e.rowIndex);
        let expanded = e.component.isRowExpanded(key);
        if (expanded) {
            e.component.collapseRow(key);
        }
        else {
            e.component.collapseAll(-1);
            e.component.expandRow(key);
            const item = e.data
            //если не прочитано, отметим
            if (!item.isRead) {
                const data = await updateReaded(item.id,true)
                if (data.isOk) {
                    item.isRead = true
                    DiffCell(e)//перерендер сообщения
                    if (lettersCount > 0) setLettersCount(lettersCount - 1)//перерендер стикера
                }
            }
        }
    }

    const DiffCell = (cellData) => {
        const data = cellData.data;
        const type = data.type
        const dateCreate = new Date(data.createdAt)
        const date_str = formatTimestamp(dateCreate)
        const isRead = data.isRead
        const className = isRead ? '' : 'not-readed'
        return (
            <div className={className + ' cursorPointer'}>
                <i className={'dx-icon-email letters-' + isRead.toString()}></i>&nbsp;
                <small>{date_str}</small><br/>
                <span className='spanItem' style={!isRead ? {fontWeight: 'bold'} : {}}>{type}</span>
            </div>
        )
    };

    return (
        <div className={'content-block dx-card responsive-paddings letters'}>
            <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faComments} />
            <h3 className="mb20"><strong>{process.env.REACT_APP_NAME_ENV === 'renergy' ? "Диалоги" : "Обращения"}</strong></h3>
            <LoadPanel visible={loading || loadingAttach} />
            {loading ?
                <p>Загрузка обращений..</p> :
                <DataGrid
                    className="lettersGrid"
                    dataSource={requests}
                    keyExpr="id"
                    allowColumnReordering={true}
                    width="100%"
                    showBorders={false}
                    // onSelectionChanged={onSelectionChanged}
                    // onContentReady={onContentReady}
                    onRowClick={onRowClick}
                    showColumnHeaders={false}
                    wordWrapEnabled={true}
                >
                    <Toolbar>
                        <Item location="before">
                            <Button
                                icon='plus'
                                type='default'
                                text='Новое обращение'
                                onClick={() => {if (dogovors.length > 0) openReqPopup(true, 1,null,[],[],false); else openReqPopup(true,3);}}
                                className={'mb-2 mr-2'}
                            />
                        </Item>
                        <Item name="searchPanel" locateInMenu={'auto'} />
                    </Toolbar>
                    <SearchPanel  visible={true} />
                    <Paging defaultPageSize={10} />
                    <Pager
                        visible={true}
                        allowedPageSizes={[5, 10, 20, 50, 'all']}
                        displayMode={'full'}
                        showPageSizeSelector={true}
                        showInfo={true}
                        showNavigationButtons={true} />
                    <Selection mode="single" />
                    <Column type="detailExpand"></Column>
                    <Column dataField="createdAt" dataType="string" cellRender={DiffCell} />
                    <MasterDetail enabled={false} render={CustomItemGrid} />
                    <Column dataField="message" dataType="string" visible={false} />
                    <Column dataField="status" dataType="string" visible={false} />
                    <Column dataField="type" dataType="string" visible={false} />
                    <Column dataField="isRead" dataType="string" visible={false} />
                    {/*<Column dataField="State" dataType="string" />*/}
                </DataGrid>
            }
        </div>
    )


    function CustomItemGrid(props) {
        const data = props.data
        const message = formatRequestMessage(data.message)
        const result = data.result
        const status = data.status
        const typeId = data.typeId
        let updatedAt
        if (data.updatedAt){
            updatedAt = new Date(data.updatedAt)
            updatedAt = formatTimestamp(updatedAt)
        }
        const attachmentsRequest = data.attachments.filter(attach => attach.direction === 0)
        const attachmentsResponse = data.attachments.filter(attach => attach.direction === 1)
        const attachmentsRequestList = createListAttach(attachmentsRequest)
        const attachmentsResponseList = createListAttach(attachmentsResponse)
        return (
            <>
                {typeId !== 8 ?
                    <>
                        <b>Текст запроса:</b><div className='white-space-pre-line'> {message}</div><br/>
                        <b>Статус:</b> {status}<br/>
                        {attachmentsRequest.length > 0 &&
                            <><b>Вложения:</b> {attachmentsRequestList}<br/></>
                        }
                        <hr/>
                        <b>{process.env['REACT_APP_TITLE' + numLogo]}:</b> <span className='white-space-pre-line'>{result} {attachmentsResponseList}</span><br/>
                        <b>Дата ответа:</b> {updatedAt && updatedAt}
                    </>
                    :
                    <>
                        {result}  {attachmentsResponseList}
                    </>
                }
            </>
        );
    }

    function formatRequestMessage(message) {
        if (message == null || message === '') return message
        return String(message).replace(/<\s*причина изменения\s*>/gi, 'впишите сюда причину смены адреса')
    }

    function createListAttach(list) {
        return (
            <React.Fragment>
                {list.length>0 &&
                    <ul>
                        {
                            list.map((attach, i) => {
                                return (
                                    <li key={'attach'+attach.idReq+i}><a href={'#/letters'} onClick={saveAttachment} id={attach.id}>{attach.name}</a></li>
                                )
                            })
                        }
                    </ul>
                }
            </React.Fragment>
        )
    }
}

export default Letters
